import { MyProfileModule } from '../modules/profile';

export default function MyProfile(): JSX.Element {
  return <MyProfileModule />;
}
